import { z } from 'zod'

const rawType = z.string().transform((v) => v.trim().toUpperCase())

const monthlyThemeTypeSchema = rawType.pipe(z.enum(['DIG', 'DMI']))

export type DDSMonthlyThemeType = z.infer<typeof monthlyThemeTypeSchema>

const monthSchema = z.coerce
	.number()
	.int('Month must be an integer')
	.min(1, 'Month must be between 1 and 12')
	.max(12, 'Month must be between 1 and 12')

export const createDDSMonthlyThemeSchema = z.object({
	month: monthSchema,
	type: monthlyThemeTypeSchema,
	description: z
		.string()
		.trim()
		.min(3, 'Description must have at least 3 characters'),
})

export const updateDDSMonthlyThemeSchema = z
	.object({
		month: monthSchema.optional(),
		type: monthlyThemeTypeSchema.optional(),
		description: z
			.string()
			.trim()
			.min(3, 'Description must have at least 3 characters')
			.optional(),
	})
	.refine(
		(data) => Object.keys(data).length > 0,
		'At least one field must be provided',
	)

// input (o que o form manda para o resolver)
export type CreateDdsMonthlyThemeInput = z.input<
	typeof createDDSMonthlyThemeSchema
>
export type UpdateDdsMonthlyThemeInput = z.input<
	typeof updateDDSMonthlyThemeSchema
>
